/* eslint-disable */
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  TextFieldProps,
} from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { useState } from 'react'
import dayjs from 'dayjs'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { useApiPost } from '../../apiCalls/useApi'
import { createBreach } from '../../apiCalls/breachApi'


// 询问关于几个date不同的地方，问一下什么时候自动，什么时候手动，区别

const dateInputStyle = {
  svg: { fontSize: '18px' },
  '.MuiInputLabel-root': {
    color: '#5B5B5B',
    transform: 'translate(14px, 16px) scale(1)',
    '&.Mui-focused, &.MuiFormLabel-filled': {
      transform: 'translate(14px, -9px) scale(0.75)',
    },
  },
  '.MuiInputBase-input': {
    color: '#5B5B5B',
    padding: '8px 14px',
  },
  '.MuiOutlinedInput-root': {
    height: '56px',
    width: '300px',
  },
}

export default function CreateBreachDialog({ open, onClose, setUpdateFlag }: any) {
  const [reportDate, setReportDate] = useState<dayjs.Dayjs | null>(null)
  const [openDate, setOpenDate] = useState<dayjs.Dayjs | null>(null)
  const [breachName, setBreachName] = useState('')

  const createNewBreach = useApiPost(createBreach)

  const handleCreate = () => {
    if (reportDate && openDate && breachName) {
      const breach = {
        reportDate: reportDate.format('YYYY-MM-DD'),
        openDate: openDate.format('YYYY-MM-DD'),
        breachName,
      }
      createNewBreach(breach).then((res: any) => {
        console.log('show res:::', res)
        if (res?.error) return
        setBreachName('')
        setReportDate(null)
        setOpenDate(null)
        onClose()
        setUpdateFlag((prev :number) => prev + 1)
      })
    }
  }

  const handleOnClose = () => {
    setReportDate(null)
    setOpenDate(null)
    setBreachName('')
    onClose()
  }

  const handleBreachNameOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 30) {
      return
    }
    setBreachName(e.target.value)
  }

  return (
    <Dialog open={open} onClose={handleOnClose}>
      <DialogTitle>Create New Breach</DialogTitle>
      <DialogContent>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              marginTop: '10px',
              alignItems: 'center',
            }}
          >
            <DatePicker
              label='Report Date'
              value={reportDate}
              onChange={(newValue) => setReportDate(newValue)}
              renderInput={(params: TextFieldProps) => (
                // eslint-disable-next-line react/jsx-props-no-spreading
                <TextField {...params} sx={dateInputStyle} />
              )}
            />
            <DatePicker
              label='Open Date'
              value={openDate}
              onChange={(newValue) => setOpenDate(newValue)}
              renderInput={(params: TextFieldProps) => (
                // eslint-disable-next-line react/jsx-props-no-spreading
                <TextField {...params} sx={dateInputStyle} />
              )}
            />
            <TextField
              label='Breach Name'
              value={breachName}
              onChange={handleBreachNameOnChange}
              sx={{ width: '300px' }}
            />
          </div>
        </LocalizationProvider>
      </DialogContent>
      <DialogActions sx={{ paddingRight: '20px' }}>
        <Button onClick={handleOnClose}>Cancel</Button>
        <Button onClick={handleCreate} variant='contained'>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  )
}
